import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import Block from "components/General/Block";
import { useState } from "react";

const ProductAttributes = ({ product_attributes }) => {
  const [showAllProperties, setShowAllProperties] = useState(false);
  if (product_attributes?.length < 1) return null;

  return (
    <Block className={`w-full p-0 bg-transparent px-8 py-8 lg:bg-light_grey bg-white`}>
      <h4 className="mb-6">Eigenschappen</h4>
      <div>
        <div className="relative flex flex-col gap-5 overflow-x-auto">
          <table className="w-full text-left">
            <tbody>
              {product_attributes?.map((attribute, idx) => {
                const hide = idx > 2 && !showAllProperties;
                if (hide) return null;

                return (
                  <tr
                    className=""
                    key={attribute?.name}
                  >
                    <th
                      scope="row"
                      className="flex pr-6 font-normal leading-7 text-13 md:text-sm whitespace-nowrap w-fit"
                    >
                      {attribute?.name}
                    </th>
                    <td className="w-full font-bold leading-7 text-13 md:text-sm text-dark-text">
                      {attribute?.value.join(", ")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {product_attributes && product_attributes?.length > 3 && (
            <button
              onClick={() => setShowAllProperties(!showAllProperties)}
              className="flex items-center gap-2 text-sm cursor-pointer text-dark-text"
            >
              <span className="underline">{showAllProperties ? "Toon minder" : "Toon alles"}</span>
              <FontAwesomeIcon
                icon={faChevronRight}
                className={`w-auto !h-2.5 mt-0.5 transition-all duration-300 ${showAllProperties && "rotate-90"}`}
              />
            </button>
          )}
        </div>
      </div>
    </Block>
  )
};

export default ProductAttributes;